import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the api
 */
export class CalcPreferenceService extends BaseService {

	constructor() {	
		super();
	}
	
	async getCalcPreferences() {
		var data = await this.makeGETRequest('/api/resource/company-calc-preferences');		
		return data;		
	}
	
	async getCalcPreferenceStage() {
		var data = await this.makeGETRequest('/api/resource/company-calc-preferences/stages');		
		return data;		
	}
	
	async updateCalcPreferences(filter) {
		var saved = await this.makePUTRequest('/api/resource/company-calc-preferences', filter);		
		return saved;		
	}	
	
}

